// @ts-check

/** How long a made-to-order piece takes to dispatch by default: five working days (Monday to Friday, no holiday calendar). */
export const DISPATCH_WORKING_DAYS = 5;

const NOT_SHIPPING_ANYMORE = ['shipped', 'delivered', 'cancelled'];

/** Days are YYYY-MM-DD strings; the arithmetic is done in UTC so the browser's timezone cannot shift a date. */
const parse = (iso) => {
  const [year, month, day] = iso.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day));
};

/**
 * The date `days` working days after `iso`. A weekend start counts from the next weekday.
 * @param {string} iso
 * @param {number} days
 */
export function addWorkingDays(iso, days) {
  const date = parse(iso);
  let left = days;
  while (left > 0) {
    date.setUTCDate(date.getUTCDate() + 1);
    const weekday = date.getUTCDay();
    if (weekday !== 0 && weekday !== 6) left -= 1;
  }
  return date.toISOString().slice(0, 10);
}

/** @param {string} today YYYY-MM-DD in India */
export const defaultDispatchDate = (today) => addWorkingDays(today, DISPATCH_WORKING_DAYS);

/**
 * True once the promised date has passed and the order has not gone out (or been cancelled).
 * @param {string | null | undefined} promised YYYY-MM-DD
 * @param {string} orderStatus
 * @param {string} today YYYY-MM-DD in India
 */
export const isDispatchOverdue = (promised, orderStatus, today) =>
  Boolean(promised) && /** @type {string} */ (promised) < today && !NOT_SHIPPING_ANYMORE.includes(orderStatus);
